import { render, staticRenderFns } from "./Poll.vue?vue&type=template&id=d665c2be&lang=pug&"
import script from "./Poll.vue?vue&type=script&lang=ts&"
export * from "./Poll.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports